import { createAPI } from '@common'

export default {
    // 读角色权限
  getPermissionAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0benjo0qfsnjttjpot0bdujpot0gpmefs', 'get', config),
  // 保存角色权限
  postPermission: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sfqptjupsz0benjo0qfsnjttjpot0bdujpot0gpmefs', 'post', config),  
}
